import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-email-templates.service";

export const useAdminEmailTemplates = createUseData(
    service.getEmailTemplates,
)